<!-- form title -->
<form class="w-12"
      [attr.name]="identifier"
      method="POST"
      novalidate="true"
      #form="ngForm">
    @if (model?.data) {
    <!-- form body -->
    @for (field of model.data.fields; track field.cid) {
    <div class="left w-12 m-b-2">
        @if (field.field_type === 'section_break') {
        <!-- section header -->
        <p class="h5 m-t block">{{field.label}}</p>
        } @else {
        <!-- fields -->
        <input-wrap form="customform"
                    [attr.name]="field.cid"
                    [required]="field.required">
            @switch (field.field_type) {
            @case ('text') {
            <!-- input: text -->
            <input class="input"
                   type="text"
                   [name]="field.cid"
                   [required]="field.required"
                   [muiInput]="field.label"
                   [(ngModel)]="data[field.cid]">
            }
            @case ('number') {
            <!-- input: number -->
            <input class="input"
                   type="number"
                   [name]="field.cid"
                   [required]="field.required"
                   [muiInput]="field.label"
                   [(ngModel)]="data[field.cid]">
            }
            @case ('email') {
            <!-- input: email -->
            <input class="input"
                   type="email"
                   [name]="field.cid"
                   [required]="field.required"
                   [muiInput]="field.label"
                   [(ngModel)]="data[field.cid]">
            }
            @case ('paragraph') {
            <!-- input: textarea -->
            <textarea class="textarea"
                      [name]="field.cid"
                      [required]="field.required"
                      [muiInput]="field.label"
                      [(ngModel)]="data[field.cid]"></textarea>
            }
            @case ('address') {
            <!-- input: address -->
            <custom-form-pca-predict [form]="form"
                                     [data]="data[field.cid]" />
            }
            @case ('dropdown') {
            <!-- input: select -->
            <select class="select"
                    [name]="field.cid"
                    [required]="field.required"
                    [(ngModel)]="data[field.cid]">
                @for (option of field.field_options.options; track $index) {
                <option [value]="option.label">{{option.label}}</option>
                }
            </select>
            }
            @case ('checkboxes') {
            <!-- input: checkbox -->
            @if(data[field.cid]){
            @for (option of field.field_options.options; let id = $index; track id;) {
            <checkbox class="w-12 m-t-2"
                      [name]="field.cid + '[]'"
                      [checkedValue]="option.label"
                      [notCheckedValue]="undefined"
                      [(ngModel)]="data[field.cid][id]"
                      (ngModelChange)="onCheckboxesChange(field)"
                      (checkedChange)="detectChanges()">
                <span class="p2"
                      [innerHtml]="option.label">
                </span>
            </checkbox>
            }
            }
            @if (field.required) {
            <input-wrap>
                <input type="hidden"
                       [name]="field.cid"
                       required
                       [(ngModel)]="checkboxes[field.cid]">
            </input-wrap>
            }
            }
            @case ('subscription') {
            <!-- input: subscription checkbox -->
            <checkbox [name]="field.cid"
                      [required]="field.required"
                      [(ngModel)]="data[field.cid]">
                <span class="p2"
                      [innerHtml]="field.field_options.options[0].label">
                </span>
            </checkbox>
            }
            @case ('radio') {
            <!-- input: radio -->
            <radio-group [name]="field.cid"
                         [required]="field.required"
                         [(ngModel)]="data[field.cid]">
                @for (option of field.field_options.options; track $index) {
                <radio class="w-12 m-t-2"
                       [value]="option.label">
                    <span class="p2"
                          [innerHtml]="option.label"></span>
                </radio>
                }
            </radio-group>
            }
            }
        </input-wrap>
        }
    </div>
    }

    <!-- submit button -->
    <div class="w-12 center">
        <button class="button m-t-2 m-b-2"
                [action]="status"
                (click)="submit()">
            <span>{{model.data.submit_button_text || ('Send' | translate)}}</span>
        </button>

        <!-- submission result -->
        <result [status]="status"
                [success]="model.data.success_message"
                class="block" />
    </div>
    }
</form>